// extracted by mini-css-extract-plugin
export default {"backdrop":"BurgerMenu_backdrop__q20BJ","top":"BurgerMenu_top__4DdVz","bottom":"BurgerMenu_bottom__b0m-f"};